import { IconMessage16 } from '@cian/ui-kit';
import { Button } from '@cian/ui-kit/button';
import { IButtonProps, TButtonTheme } from '@cian/ui-kit/button/types';
import cn from 'classnames';
import * as React from 'react';

import { useChats } from '../../../common/hooks/useChats';
import { IDailyRentOfferForMobileSite } from '../../../common/repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';
import * as styles from '../Buttons/Buttons.css';

interface IChatButtonProps {
  offer: IDailyRentOfferForMobileSite;
  // фоллбэк на случай, если isChatsEnabled придет false
  alwaysShow?: boolean;
  title?: string;
  theme?: TButtonTheme;
  short?: boolean;
  size?: IButtonProps['size'];
  onClick(): void;
}

export const ChatButton = ({
  offer,
  short,
  theme = 'fill_secondary',
  size = 'M',
  onClick: onClickProp,
}: IChatButtonProps) => {
  const { isEnabled, openChat } = useChats(offer);
  const [loading, setLoading] = React.useState(false);

  const onClick = React.useCallback(async () => {
    setLoading(true);
    openChat()
      .then(onClickProp)
      .finally(() => setLoading(false));
  }, [openChat, onClickProp]);

  if (!isEnabled) {
    return null;
  }

  if (short) {
    return (
      <div className={cn(styles['button-container'], styles['button-container_short'])}>
        <Button
          beforeIcon={<IconMessage16 color="primary_100" />}
          onClick={onClick}
          fullWidth
          size={size}
          theme={theme}
          loading={loading}
          disabled={loading}
          aria-label="Написать"
        />
      </div>
    );
  }

  return (
    <div className={styles['button-container']}>
      <Button onClick={onClick} fullWidth size={size} theme={theme} loading={loading} disabled={loading}>
        Написать
      </Button>
    </div>
  );
};
